import {Controller} from '@hotwired/stimulus';

/**
 * Formulaire réparti en onglets, imbriqués ou non : à l'affichage, ouvre les onglets qui contiennent le premier
 * champ en erreur (`.is-invalid` dans un `.tab-pane`), du plus extérieur au plus intérieur, puis demande un défilement
 * doux jusqu'à lui, que Chromium ignore tant que la page n'a pas fini de charger. Les onglets s'ouvrent par un clic sur
 * leur déclencheur `data-bs-toggle="tab"` (`data-bs-target` ou `href` vers l'id du volet), cherché dans l'élément qui
 * porte le contrôleur.
 *
 *   {{ form_start(form, {attr: stimulus_controller('invalid-tab-reveal').toArray()}) }}
 */
export default class extends Controller {
  connect() {
    const firstInvalid = this.element.querySelector('.tab-pane .is-invalid');

    if (!firstInvalid) {
      return;
    }

    this.#panesOf(firstInvalid).forEach((pane) => {
      const id = CSS.escape(pane.id);

      this.element
        .querySelector(`[data-bs-toggle="tab"][data-bs-target="#${id}"], [data-bs-toggle="tab"][href="#${id}"]`)
        ?.click();
    });

    firstInvalid.scrollIntoView({behavior: 'smooth', block: 'center'});
  }

  #panesOf(element) {
    const panes = [];
    let pane = element.closest('.tab-pane');

    while (pane && this.element.contains(pane)) {
      panes.unshift(pane);
      pane = pane.parentElement?.closest('.tab-pane');
    }

    return panes;
  }
}
